<div class="priceDetailCardDs__cont">
  <div class="priceDetailCardDs__header">
    <div class="priceDetailCardDs__header-title priceDetailCardDs__header-title-{{type}}">
      <app-ds-typography
        [text]="title"
        [size]="fontSize.XS"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Primary">
      </app-ds-typography>
      <ng-container *ngIf="isEmbedded">
        <app-ds-button-icon
          [buttonSize]="buttonIconSize"
          [icon]="closeIcon"
          [iconSize]="20"
          (clickEvent)="closeEvent.emit()">
        </app-ds-button-icon>
      </ng-container>
    </div>
    <app-ds-divider *ngIf="!isEmbedded"></app-ds-divider>
  </div>
  <ng-container *ngIf="subtitles?.length">
    <div class="priceDetailCardDs__subtitles">
      <ng-container *ngFor="let subtitles of subtitles; trackBy: trackById">
        <div class="priceDetailCardDs__subtitle">
          <app-ds-typography
            class="priceDetailCardDs__subtitle-label"
            [text]="subtitles.Label"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary">
          </app-ds-typography>
          <app-ds-typography
            class="priceDetailCardDs__subtitle-description"
            [text]="subtitles.Description"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary">
          </app-ds-typography>
        </div>
      </ng-container>
      <app-ds-divider></app-ds-divider>
    </div>
  </ng-container>
  <ng-container *ngIf="rows?.length">
    <ng-container *ngFor="let row of rows; last as isLast; trackBy: trackById">
      <div class="priceDetailCardDs__items">
        <ng-container *ngFor="let item of row; trackBy: trackById">
          <ng-container *ngIf="item">
            <div class="priceDetailCardDs__item">
              <div class="priceDetailCardDs__item-description">
                <app-ds-typography
                  class="priceDetailCardDs__item-description-label"
                  [text]="item.Label"
                  [size]="fontSize.XXS"
                  [color]="item.Disabled ? fontColor.Disabled : fontColor.Primary">
                </app-ds-typography>
                <app-ds-typography
                  class="priceDetailCardDs__item-description-amount"
                  [text]="item.Amount"
                  [size]="fontSize.XXS"
                  [color]="item.Disabled ? fontColor.Disabled : fontColor.Primary">
                </app-ds-typography>
              </div>
              <ng-container *ngIf="item?.Info">
                <div class="priceDetailCardDs__item-info">
                  <app-ds-typography
                    [text]="item.Info"
                    [size]="fontSize.XXS"
                    [color]="fontColor.Secondary">
                  </app-ds-typography>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-container *ngIf="!isLast">
        <app-ds-divider></app-ds-divider>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="discount">
    <div class="priceDetailCardDs__discount">
      <div class="priceDetailCardDs__discount-description">
        <app-ds-typography
          [text]="discount.Label"
          [size]="fontSize.XXS"
          [color]="discountLabelColor">
        </app-ds-typography>
        <ng-container *ngIf="discount.TagMemberLabel">
          <app-ds-tag-member
            class="priceDetailCardDs__discount-tag"
            [label]="discount.TagMemberLabel"
            [type]="discount.TagMemberType">
          </app-ds-tag-member>
        </ng-container>
      </div>
      <div class="priceDetailCardDs__discount-amount">
        <app-ds-typography
          [text]="discount.Amount"
          [size]="fontSize.XXS"
          [color]="discountAmountColor">
        </app-ds-typography>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="total">
    <app-ds-divider></app-ds-divider>
    <div class="priceDetailCardDs__total">
      <div class="priceDetailCardDs__total-description" [class.non-space]="!subtotal">
        <app-ds-typography
          class="priceDetailCardDs__total-description-label"
          [text]="total?.Label"
          [size]="fontSize.XS"
          [fontFamily]="fontFamily.SemiBold"
          [color]="fontColor.Primary">
        </app-ds-typography>
        <app-ds-typography
          class="priceDetailCardDs__total-description-amount"
          [text]="total?.Amount"
          [size]="fontSize.XS"
          [fontFamily]="fontFamily.SemiBold"
          [color]="fontColor.Primary">
        </app-ds-typography>    
      </div>
      <ng-container *ngIf="subtotal">
        <div class="priceDetailCardDs__subtotal-description non-space">
          <app-ds-typography
            class="priceDetailCardDs__subtotal-description-label"
            [text]="subtotal?.Label"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary">
          </app-ds-typography>
          <app-ds-typography
            class="priceDetailCardDs__subtotal-description-amount"
            [text]="subtotal?.Amount"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary">
          </app-ds-typography>    
        </div>
      </ng-container>
      <ng-container *ngIf="total?.Info">
        <div class="priceDetailCardDs__total-info">
          <app-ds-alert
            [size]="alerSize"
            [icon]="warningIcon"
            [message]="total.Info">
          </app-ds-alert>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>